import {PriorityIcon} from '@priority-software/priority-style-react';
import {ReportDialogProps, ReportDialogOption, ExcelMappedTemplate} from '../types';
import {isPluginDisabled} from '../../../_shared/GWTBridge/invoke/common';
import texts from '../texts';

export function generateReportOptions(props: ReportDialogProps): ReportDialogOption[] {
    const {showreport, showfile, showexcel, showtable, showgraph, showdesign} = props;
    return [
        {
            mode: 'H',
            title: `${texts.displayReport}`,
            tooltip: `${texts.displayReportTooltip}`,
            icon: PriorityIcon.showPasswordThin,
            hide: showreport === '0',
            formats: true,
            design: showdesign === '1' && texts.designReport,
            checkbox: texts.pdf
        },
        {
            mode: 'x',
            submode: 'p', // 'p' if locked excel
            title: `${texts.excel}`,
            tooltip: `${texts.excelTooltip}`,
            icon: PriorityIcon.exportExcel,
            hide: showexcel === '0',
            excelTemplates: true,
            design: showdesign === '1' && texts.designExcel,
            checkbox: texts.lockedFile
        },
        {
            mode: 'X',
            title: `${texts.file}`,
            tooltip: `${texts.fileTooltip}`,
            icon: PriorityIcon.fileThin,
            hide: showfile === '0' || isPluginDisabled(),
            design: showdesign === '1' && texts.designReport
        },
        {
            mode: 'I',
            title: `${texts.table}`,
            tooltip: `${texts.tableTooltip}`,
            icon: PriorityIcon.tableView,
            hide: showtable === '0',
            formats: true,
            design: showdesign === '1' && texts.designReport,
            checkbox: texts.pdf
        },
        {
            mode: 'J',
            title: `${texts.graph}`,
            tooltip: `${texts.graphTooltip}`,
            icon: PriorityIcon.graph,
            hide: showgraph === '0'
        }
    ];
}

export function getFormats(props: ReportDialogProps) {
    const {Formats} = props;
    return Formats?.map(format => {
        return {value: format.format, label: format.title, isSelected: format.selected === '1'};
    });
}

export function getExcelTemplates(props: ReportDialogProps) {
    const {ExcelTemplates} = props;
    const templates: Array<ExcelMappedTemplate> = [];
    if (ExcelTemplates) {
        for (const template of ExcelTemplates) {
            const t = {
                ...template,
                ...{
                    value: template.template,
                    label: template.title,
                    isOld: template.oldtemplate === '1'
                }
            };
            template.template === '-1' ? templates.unshift(t) : templates.push(t);
        }
    }
    return templates;
}

export function getSavedReports(props: ReportDialogProps) {
    return props.Saved;
}
